import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import LogoutIcon from 'Icons/Logout';
import useUserContext from 'Context/UserContext';

const styles = (theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
  },
});

const LogoutButton = ({
  className,
  classes,
  compact,
  ...rest
}) => {
  const { logout } = useUserContext();

  if (compact) {
    return (
      <Button variant="icon" onClick={logout} test={'log-out-button'} {...rest}><Icon icon={LogoutIcon} fill="primaryGray" className={classes.compactIcon} /></Button>
    );
  }
  return (
    <Button onClick={logout} test={'log-out-button'} {...rest}>{'Log out'}<Icon icon={LogoutIcon} fill="primaryGray" className={classes.icon} /></Button>
  );
};

LogoutButton.defaultProps = {
  className: '',
  compact: false,
};

LogoutButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  compact: PropTypes.bool,
};

export default withStyles(styles)(LogoutButton);
